import { ReportingTransactionsModel } from '../../../models';
import { Observable } from 'rxjs';

export abstract class IReportingService {
  abstract getReportingPartners(
    country: string,
    startDate: string,
    endDate: string,
    theaterCode?: string,
  ): Promise<ReportingTransactionsModel[]>;
  abstract getReportingTransactions(
    country: string,
    startDate: string,
    endDate: string,
    theaterCode?: string,
  ): Promise<ReportingTransactionsModel[]>;

  abstract getReportingTransactionsWithPagination(
    country: string,
    startDate: string,
    endDate: string,
    pageIndex: number,
    theaterCode?: string,
  ): Observable<{ data: ReportingTransactionsModel[]; total: number; hasMore: boolean }>;

  abstract getReportingPartnersWithPagination(
    country: string,
    startDate: string,
    endDate: string,
    pageIndex: number,
    theaterCode?: string,
  ): Observable<{ data: ReportingTransactionsModel[]; total: number; hasMore: boolean }>;

  abstract getAllParsedTransactionsForExport(
    country: string,
    startDate: string,
    endDate: string,
    isPartner: boolean,
    theaterCode?: string,
  ): Observable<ReportingTransactionsModel[]>;

  abstract resetCache(): void;
}
